module.exports = "<a href=\"#\" class=\"csng-synthetic-link back-to-top\" data-target=\"body\" data-duration=\"700\" data-offset=\"120\"><%= backToTopLabel %></a>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/cigna_csg_gsg_elasticsearch/src/js/views/back-to-top.tpl.html
// module id = 6CAq
// module chunks = 4